import { Component, OnInit, ViewContainerRef, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../Services/UserService';
import { Userclass } from '../Classes/Userclass';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgForm } from '@angular/forms';
import { IMyDpOptions, IMyInputFieldChanged, IMyDateModel } from 'mydatepicker';
import { UserPunch } from '../Classes/UserPunch';
import { debug, error } from 'util';
import * as XLSX from 'xlsx'; 
import { FaceApiService } from '../Services/face-api-service.service';
import * as _ from 'lodash';
import { reverse } from 'dns';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Time } from '@angular/common';
//@import '~@angular/material/prebuilt-themes/deeppurple-amber.css';


@Component({
  selector: 'User-Manage',
  templateUrl: '../UserPunchFaces/PunchUser.Component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css', '../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css',
    '../../Content/css/table-sorting-example.css'],
  providers: [UserService, FaceApiService],
 // encapsulation: ViewEncapsulation.None
})

export class UserPunchFacesComponent implements OnInit, AfterViewInit {
  
  _UserPunch = new UserPunch();
  _user = new Userclass();
  GetUserDetails: any[] = [];
  GetUserDetailsFiltered: any[] = [];
  dataSource: any = {};
  displayedColumns: any[] =[];
  _SelectedDate: string;
  innerWidth: number;
  GetUserRoles: any = [];
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
 // fullImagePath: string = '../../Content/images/cal/defalut.jpg';
  loading: boolean = false;
  isColumnHidden: boolean = false;
  UserAdd: string = "none";

  PermissionRole: string;
  TitleName: string;
  selectAllRows: boolean = false;
  selectAllRowss: boolean = false;
  shouldBelowTen: boolean = false;
  booleanValue: any = false;
  // these are use for Azure linking
  public personFaces = [];
  public personGroups = [];
  public personList = [];
  public selectedGroupId = '';
  public selectedPerson: any;



  public myDatePickerStartdateOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    editableDateField: false,
    inline: false,
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };


  UserStatus: any[] = [
    { Value: 'Active', Text: 'Active' },
    { Value: 'Inactive', Text: 'Inactive' }
  ]
  isValidFormSubmitted = false;
  @ViewChild(MatSort) sort: MatSort

  constructor(private route: ActivatedRoute, private router: Router, private _userservice: UserService, private _FaceApiService: FaceApiService,
    public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }

  ngOnInit() {

    this.displayedColumns = ['checked', 'tenantID', 'ehid', 'userName', 'dateTime', 'percentageMatch', 'image', 'persistedFaceIds', 'personGroupId', 'personId', 'uniqueno','date'];
    this.ChangeHeadeFooterColor();
    this._UserPunch.UserPunchSearchDate = { jsdate: new Date() };

    const ELEMENT_DATA: Element[] = [];
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   // GetAllUserdetails();
    //this.GetAllRoles();
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  GetAllUserdetails(_SelectedDate: string) {
    this.loading = true;

    //this._UserPunch.UserPunchSearchDate = ;
    localStorage.object = _SelectedDate;
    //var cost= localStorage.getItem(_SelectedDate);
    this._userservice.GetPunchImagesbyDate(_SelectedDate).subscribe(res => {
      var data = res;
      this.GetUserDetails = data
        .map(item => {
          item.checked = false;
          item.image = this.Loaderimage;
          return item;
        });
      this.GetUserDetailsFiltered = this.GetUserDetails;
      const ELEMENT_DATA: Element[] = this.GetUserDetailsFiltered || [];
      this.dataSource = new MatTableDataSource(ELEMENT_DATA);
      this.dataSource.sort = this.sort;

      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'dateTime': return new Date(item.dateTime);
          default: return item[property];
        }
      };
    
      this.loading = false;
    })
  }

  onChangeBelowTen() {
    
    if (this.shouldBelowTen) {
      this.selectAllRows = false;
       this.GetUserDetailsFiltered =
         this.GetUserDetails.map(item => {
           if (+item.percentageMatch < 10) {
             item.checked = true;
           } else {
             item.checked = false;
           }
           return item;
         });
    } else {
       this.GetUserDetailsFiltered = this.GetUserDetails.map(item => {
         
           item.checked = false;
         
         return item;
       });;
    }
  }   

  onSelectAll() {
    this.selectAllRowss = false;
    if (this.selectAllRows) {
      this.shouldBelowTen = false;
      this.GetUserDetailsFiltered = this.GetUserDetailsFiltered.map(item => {
        item.checked = true;
        item.date = formatDate(item.date);
        return item;
      });
    } else {
      this.GetUserDetailsFiltered = this.GetUserDetailsFiltered.map(item => {
        item.checked = false;
        return item;
      });
    }
  }

  
  onRowSelect() {

    

    if (this.GetUserDetailsFiltered.length ==
      this.GetUserDetailsFiltered.filter(item => item.checked).length) {
        this.selectAllRows = true;
      
    }
    else {
      this.selectAllRows = false;
          
    }


    
  }

  exportExcel() {
    const data = Object.assign([], JSON.parse(JSON.stringify(this.GetUserDetailsFiltered.filter(item => item.checked))));//(this.GetUserDetailsFiltered);
    const dataforExport = data.map(item => {
      delete item.image;
      delete item.checked;
      delete item.uniqueno;
      delete item.percentageMatch;
      delete item.lettercode;
      delete item.personGroupId;
      delete item.personId;
      delete item.persistedFaceIds;
      delete item.rowID;
      delete item.dateTime
      return item;
    });
    
    if (dataforExport.length!=0) {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataforExport);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Failed Punch Faces');
      XLSX.writeFile(wb, 'Failed Punch Faces.xlsx');
    }
    else
    {
      this.toastr.error('Please select failed Punch.');
      this.loading = false;
      return;
    }
    

  }

  public DeleteDevice(Userdetails: any) {
    
          // this._user.TenantId, this._user.Hotelid,
    this._user.Useruniqueno = Userdetails.uniqueno;
    this._user.TenantId = Userdetails.personGroupId;
    this._user.Hotelid = Userdetails.tenantID;
    if (confirm("Are you sure to delete this Punch Faces ?")) {
      // delete data from Azure.
      var persistedFaceId = Userdetails;
      this.deletePersonFace(persistedFaceId)

      //===================================
      this._userservice.deleteFailedPunch(this._user.Useruniqueno + "," + this._user.TenantId + "," + this._user.Hotelid).subscribe(res => {
        var data = res;
        if (data == "") {

          this.toastr.success("Punch Faces deleted successfully.");
         
          this._userservice.GetPunchImagesbyDate(localStorage.object).subscribe(res => {
            var data = res;
            this.GetUserDetails = data
              .map(item => {
                item.checked = false;
                item.image = this.Loaderimage;
                return item;
              });
            this.GetUserDetailsFiltered = this.GetUserDetails;
            const ELEMENT_DATA: Element[] = this.GetUserDetailsFiltered;
            this.dataSource = new MatTableDataSource(ELEMENT_DATA);
            this.dataSource.sort = this.sort;
            this.dataSource.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'dateTime': return new Date(item.dateTime);
                default: return item[property];
              }
            };
            this.loading = false;
          })

        }
      

      });

      //this._userservice.GetPunchImagesbyDate(_SelectedDate).subscribe(res => {
    }
  }

  deletePersonFace(persistedFaceId) {
    
    this.selectedGroupId = persistedFaceId.personGroupId;
    this.selectedPerson = persistedFaceId.personId;
     
    //this._FaceApiService.deletePersonFace(this.selectedGroupId, this.selectedPerson, persistedFaceId.persistedFaceIds).subscribe(() => {
    //  _.remove(this.personFaces, x => x.persistedFaceId === persistedFaceId);

      this._FaceApiService.deletePerson(this.selectedGroupId, this.selectedPerson).subscribe(() => {
        _.remove(this.personList, x => x.personId === this.selectedPerson);
        this.selectedPerson = null;
      //});


    });
  }


  


  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  GetAllRoles() {
    this._userservice.GetAllRoles().subscribe(res => {
      var data = res;
      this.GetUserRoles = data;
    })
  }

  SaveUserDetails(form: NgForm) {
    this._user.BCCEmail = sessionStorage.getItem('BCCEmail');
    this._user.FirstName = this._user.FirstName.trim();
    this._user.FirstName = this._user.FirstName.charAt(0).toUpperCase() + this._user.FirstName.slice(1).toLowerCase();
    this._user.LastName = this._user.LastName.trim();
    this._user.LastName = this._user.LastName.charAt(0).toUpperCase() + this._user.LastName.slice(1).toLowerCase();
    var LnameLength = this._user.LastName.length;
    var LastChar = this._user.LastName.substring(LnameLength - 1, LnameLength)

    if (this.isInteger(LastChar)) {
      this.toastr.error('Please enter the valid Last Name.');
      return;
    }
    this._user.Email = this._user.Email.trim();
    this._user.UserName = "";
    this.loading = true;
    this._userservice.SaveUserDetails(this._user).subscribe(res => {
      var data = res;
      if (!data.Message) {
        this.toastr.success(data[0].message);
        this.UserAdd = "none";
       // this.GetAllUserdetails();
        this.loading = false;
        form.reset();
      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }




  EditUserInfo(Userdetails: any) {
    
    this.loading = true;
   // this.selectedPerson.personId = "c865cd0b-0027-4b94-aa02-32e936f7bf59";// Userdetails;// person;
    this.selectedPerson = Userdetails;
    this.personFaces = [];
    
    this._FaceApiService.getPersonFaces(this.selectedPerson.personGroupId,
      this.selectedPerson.personId).subscribe((person:any) => {
        
        for (const faceId of person.value.persistedFaceIds) {
          this._FaceApiService.getPersonFace(this.selectedPerson.personGroupId,
            this.selectedPerson.personId, faceId).subscribe(data => {
              this.personFaces.push(data);
            });
        }

      this._user.Type = "Update";
      this.UserAdd = "block";
        this.loading = false;

      }, error => {
          if(error.status ===404){
            this.loading = false;
            this.toastr.error("The face is not found.");
          }
    });
  }

//  , error => {

//  this.loading = false;
//  this.toastr.error("The face is not found.");
//}


  AddNew() {
    this._user.FirstName = null;
    this._user.LastName = null;
    this._user.UserName = null;
    this._user.Email = null;
    this._user.Status = this.UserStatus[0].Value;
    this._user.RoleID = null;
    this._user.Useruniqueno = null;
    this.PermissionRole = null;
    this._user.Type = "Add";
    this.UserAdd = "block";
    this.TitleName = "Create New User";
  }


  HidePwdPopUp(form: NgForm) {
    this.UserAdd = "none";
    form.reset();
  }

  isInteger(value) {
  if (value.indexOf('.') != -1) {
    return false;
  }
  if ((undefined === value) || (null === value)) {
    return false;
  }
  return value % 1 == 0;
  }

  TrimEmail(Email: string) {
    this._user.Email = Email.trim();
    return this._user.Email;
  }

  //CombineFirstLastname(FirstName: string, Lastname: string) {
  //  return FirstName.trim().charAt(0).toLocaleUpperCase() + FirstName.slice(1).toLocaleLowerCase()
  //    + '.' + Lastname.trim().charAt(0).toLocaleUpperCase() + Lastname.slice(1).toLocaleLowerCase();
  //}


  public BtnSearch() {
    this.loading = true;
    this.shouldBelowTen = false;
    this.selectAllRows = false;
     if (this._UserPunch.UserPunchSearchDate != null) {
      if (!this._UserPunch.UserPunchSearchDate.jsdate) {
        this._UserPunch.UserPunchSearchDate = this._UserPunch.UserPunchSearchDate;
      } else {
        this._UserPunch.UserPunchSearchDate = formatDate(this._UserPunch.UserPunchSearchDate.jsdate);
      }
      
      this.GetAllUserdetails(this._UserPunch.UserPunchSearchDate);
    }
    else {
      this.toastr.error('Please select date.');
      this.loading = false;
      return;
    }
  }


}


export interface Element {
  tenantID: number;
  ehid: number;
  userName: string;
  dateTime: string;
  percentageMatch: string;
  image: string;
  checked: boolean;
  persistedFaceIds: string;
  personGroupId: string;
  personId: string;
  uniqueno: string;
  date: string;
 
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}



// WEBPACK FOOTER //
// ./src/app/UserPunchFaces/UsersComponent.ts